import React, { useEffect, useState } from 'react';
import './PrivacyNotice.css';
import {
  getConsentState,
  initializeAnalyticsConsent,
  setConsentState,
  subscribeToConsentChanges,
} from '../../services/analytics';

function getConsentLabel(consentState) {
  if (consentState === 'accepted') return 'Accepted';
  if (consentState === 'rejected') return 'Declined';
  return 'Not set';
}

function PrivacyNotice() {
  const [consentState, setLocalConsentState] = useState(() => getConsentState());

  useEffect(() => {
    initializeAnalyticsConsent();
    return subscribeToConsentChanges(setLocalConsentState);
  }, []);

  return (
    <article className="privacy-page">
      <section className="privacy-page__section fade-in">
        <div className="privacy-page__card">
          <span className="privacy-page__eyebrow">Privacy</span>
          <h1>Cookie &amp; Analytics Notice</h1>
          <p>
            We use analytics to understand how visitors use integra3646.com and IntegrAI so we can improve reliability
            and user experience. If you allow analytics, we may measure events such as page visits, IntegrAI requests,
            response times, and errors. We do not send raw IntegrAI questions to analytics. We only send limited
            technical metadata such as request counts, latency, language hint, and error type. You can accept or decline
            analytics tracking.
          </p>

          <div className="privacy-page__status">
            <span className="privacy-page__status-label">Current analytics choice</span>
            <strong>{getConsentLabel(consentState)}</strong>
          </div>

          <div className="privacy-page__actions">
            <button type="button" className="privacy-page__button privacy-page__button--primary" onClick={() => setConsentState('accepted')}>
              Accept Analytics
            </button>
            <button type="button" className="privacy-page__button privacy-page__button--secondary" onClick={() => setConsentState('rejected')}>
              Decline
            </button>
          </div>
        </div>
      </section>

      <section className="privacy-page__section fade-in">
        <div className="privacy-page__grid">
          <div className="privacy-page__panel">
            <h2>What we measure</h2>
            <p>Analytics is optional. If you accept, we may record visits, IntegrAI request counts, latency, and technical error events.</p>
          </div>
          <div className="privacy-page__panel">
            <h2>What we do not send</h2>
            <p>Raw IntegrAI query text is not sent to analytics. The analytics payload is limited to non-sensitive technical metadata.</p>
          </div>
          <div className="privacy-page__panel">
            <h2>Your choice</h2>
            <p>You can accept or decline analytics tracking, and your choice can be changed later from this page.</p>
          </div>
        </div>
      </section>
    </article>
  );
}

export default PrivacyNotice;
